import { Injectable } from '@angular/core';
import { commercialConstants } from 'app/common/commercial-constants';

@Injectable()
export class PolicyInfoService {
    private normalizeProgramName(value: string): string {
        return (value || '').replace(/[()]/g, '').trim();
    }

    getDisplayName(policy: any): string {
        let prefix = policy.prefixB;
        if (prefix === undefined) {
            prefix = policy.policyPrefix;
        }
        if (prefix !== undefined) {
            for (const type of commercialConstants.packageInfo) {
                for (const key of type.prefixes) {
                    if (prefix.startsWith(key)) {
                        return type.display;
                    }
                }
            }
        }
        if (policy.programName) {
            return this.normalizeProgramName(policy.programName) || policy.programName;
        } else {
            return 'Commercial Policy';
        }
    }

    // eslint-disable-next-line sonarjs/cognitive-complexity
    getIcon(prefix: string, contentfulData?: any): any {
        for (const policy of commercialConstants.packageInfo) {
            for (const key of policy.prefixes) {
                if (prefix.startsWith(key)) {
                    if (contentfulData) {
                        if (contentfulData[policy.tridionIdentifier]) {
                            return contentfulData[policy.tridionIdentifier];
                        } else {
                            return undefined;
                        }
                    } else {
                        return policy.mobileIcon;
                    }
                }
            }
        }
    }
}
